import { useNavigate } from 'react-router-dom'
import { Table, Input, Label } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function RetrievexForm() {
  console.log('RetrievexForm rendered')

  let initialInputs = {
    retrievexNumber: '',
    retrievexNumberNulls: null,
    retrievexB: '',
    retrievexBNulls: null,
    orderBy: '1',
    orderDir: 'DESC'
  }

  const navigate = useNavigate()
  initialInputs = initialFormValues('RetrievexForm', navigate, initialInputs)
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('RetrievexForm', navigate, inputs, 'reports.retrievex')
    inputs.retrievexNumberNulls = (inputs.retrievexNumberNulls === 'on' || inputs.retrievexNumberNulls === 'Y') ? 'Y' : ''
    inputs.retrievexBNulls = (inputs.retrievexBNulls === 'on' || inputs.retrievexBNulls === 'Y') ? 'Y' : ''
    console.log('RetrievexForm.submitSearch', inputs)
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table">
            <FormHeading headingText='Retrievex Report' />
            <tbody>
              <tr >
                <td><Label><b>Retrievex Number</b></Label></td>
                <td>
                  <Input className="custom-input" size="50" name="retrievexNumber" onChange={handleInputChange} defaultValue={inputs.retrievexNumber} />
                  <Input className="custom-checkbox" type="checkbox" name="retrievexNumberNulls" onChange={handleInputChange} defaultChecked={inputs.retrievexNumberNulls} /><span> Exclude Nulls</span>
                </td>
              </tr>
              <tr>
                <td><Label><b>Retrievex B</b></Label></td>
                <td>
                  <Input className="custom-input" size="50" name="retrievexB" onChange={handleInputChange} defaultValue={inputs.retrievexB} />
                  <Input className="custom-checkbox" type="checkbox" name="retrievexBNulls" onChange={handleInputChange} defaultChecked={inputs.retrievexBNulls} /><span> Exclude Nulls</span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}